import { useCallback } from 'react';
import type React from 'react';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { LazyComponent, ScrollableComponent } from '#src/app/shared/components/layout/lazy';
import { useCountryCode } from '#src/app/shared/hooks/l10n';

import { LocalSectionSkeleton } from '../skeletons';

export const LazyLocalSection: React.FC = () => {
	const countryCode = useCountryCode();
	const loadComponent = useCallback(
		async () => (await import(/* webpackChunkName: "pages/homepage-localSection" */ '../LocalSection')).LocalSection,
		[],
	);

	// the section only has data for US locations; countryCode is available synchronously
	// on both server and client (and is part of the SSR cache key), so gating here
	// prevents the skeleton from ever rendering for non-US users
	if (countryCode !== 'US') return null;

	return (
		<ClientRender placeholder={<LocalSectionSkeleton />}>
			<ScrollableComponent topOffset={200} immediateForBots fallback={<LocalSectionSkeleton />}>
				<LazyComponent loadComponent={loadComponent} fallback={<LocalSectionSkeleton />} />
			</ScrollableComponent>
		</ClientRender>
	);
};
